import { environment } from '../../../../../../environments/environment';

/**
 * LocalStack URL Helper
 *
 * When running locally with LocalStack, the backend (Django in Docker) uses
 * `host.docker.internal:4566` to reach LocalStack, but the browser needs
 * `localhost:4566` to access it.
 *
 * This function automatically replaces the URL only in local development
 * (when environment.name === 'default').
 *
 * In deployed environments (dev/uat/prod), it returns the URL unchanged.
 *
 * @param url - The original S3 URL (may contain host.docker.internal)
 * @returns The corrected URL for the browser (with localhost if needed)
 *
 * @example
 * ```TypeScript
 * // Local environment
 * const url = 'http://host.docker.internal:4566/bucket/file.pdf';
 * const fixed = fixLocalStackUrl(url);
 * // Returns: 'http://localhost:4566/bucket/file.pdf'
 *
 * // Dev/Prod environment
 * const url = 'https://s3.amazonaws.com/bucket/file.pdf';
 * const fixed = fixLocalStackUrl(url);
 * // Returns: 'https://s3.amazonaws.com/bucket/file.pdf' (unchanged)
 * ```
 */
export function calcConditionalEnvBasedUrl(url: string): string {
  // Only apply the workaround in local development (default environment)
  if (environment.name === 'default' && url.includes('host.docker.internal')) {
    return url.replace('host.docker.internal', 'localhost');
  }

  // In all other environments (dev, uat, prod), return URL unchanged
  return url;
}
